export const getYear = state => state.reportCustomerMonthlyPlans.getIn(['list', 'year'])
export const getSettings = state => state.reportCustomerMonthlyPlans.getIn(['list', 'settings'])
export const getData = state => state.reportCustomerMonthlyPlans.getIn(['list', 'data'])
export const getFetching = state => state.reportCustomerMonthlyPlans.getIn(['list', 'fetching'])
export const getError = state => state.reportCustomerMonthlyPlans.getIn(['list', 'error'])
